/**
 * Enumerator of version name
 * @source
 */
var LisioVersionNames;
(function (LisioVersionNames) {
    LisioVersionNames["ESSENTIAL"] = "essential";
    LisioVersionNames["COMPLETE"] = "complete";
    LisioVersionNames["FIRST"] = "first";
    LisioVersionNames["WELCOME"] = "welcome";
})(LisioVersionNames || (LisioVersionNames = {}));
/**
 * Function to convert db version number to widget version number
 * @param {number} versionNumber - Numeric version number
 * @returns - Returns widget version
 * @throws Throw error if version not existing
 */
function lisioVersionConverter(versionNumber) {
    const versions = Object.values(LisioVersionNames);
    if (versionNumber > versions.length) {
        throw new Error("Version not existing");
    }
    else {
        return versions[versionNumber - 1];
    }
}
export { LisioVersionNames, lisioVersionConverter };
